import styles from "./Panel.module.scss";
import { FILTERS_FOLDERS_PANEL_TESTID } from "../../constants/test-ids";

interface defaultProps {
  title: string;
  children: JSX.Element;
  enableResize?: boolean;
  minWidth?: number | string;
  maxWidth?: number | string;
}

const AUTO_WIDTH = "auto";
export const Panel = ({
  maxWidth = AUTO_WIDTH,
  minWidth = AUTO_WIDTH,
  children,
}: defaultProps) => {
  return (
    <div
      className={styles.panel}
      style={{ minWidth, maxWidth }}
      id="filter_folder_panel"
      data-testid={FILTERS_FOLDERS_PANEL_TESTID}
    >
      {children}
    </div>
  );
};
